import type { LangMap } from "./index";

export const quiz: LangMap = {
  en: {
    eyebrow: "Study",
    title: "Quiz",
    subtitle: "Test yourself with multiple-choice questions.",
    tabMine: "My quizzes",
    tabCreate: "Create",
    emptyList: "No quizzes yet. Create one in the \"Create\" tab.",
    questionsCount: "{{count}} questions",
    start: "Start",
    topicLabel: "Topic",
    topicPlaceholder: "E.g. Circulatory system",
    subjectLabel: "Subject",
    subjectPlaceholder: "E.g. Biology",
    difficultyLabel: "Difficulty",
    difficultyBase: "Basic",
    difficultyMedium: "Medium",
    difficultyAdvanced: "Advanced",
    sourceLabel: "Source text (optional)",
    sourcePlaceholder: "Paste notes, or attach an audio or photo of your notes.",
    countLabel: "Number of questions: {{count}}",
    generating: "Generating quiz…",
    generateWithAi: "Generate with AI",
    readyToast: "Quiz \"{{title}}\" ready",
    perfectResult: "Perfect! You unlocked a badge.",
    keepGoing: "Keep it up.",
    backToQuizzes: "Back to quizzes",
    questionOf: "Question {{current}} of {{total}}",
    exit: "Exit",
    next: "Next",
    submitting: "Submitting…",
    finish: "Finish",
  },
  it: {
    eyebrow: "Studio",
    title: "Quiz",
    subtitle: "Mettiti alla prova con domande a scelta multipla.",
    tabMine: "I miei quiz",
    tabCreate: "Crea",
    emptyList: "Nessun quiz ancora. Creane uno nella scheda \"Crea\".",
    questionsCount: "{{count}} domande",
    start: "Inizia",
    topicLabel: "Argomento",
    topicPlaceholder: "Es. Sistema circolatorio",
    subjectLabel: "Materia",
    subjectPlaceholder: "Es. Biologia",
    difficultyLabel: "Difficolta'",
    difficultyBase: "Base",
    difficultyMedium: "Medio",
    difficultyAdvanced: "Avanzato",
    sourceLabel: "Testo di partenza (opzionale)",
    sourcePlaceholder: "Incolla appunti, oppure allega un audio o una foto degli appunti.",
    countLabel: "Numero domande: {{count}}",
    generating: "Genero il quiz…",
    generateWithAi: "Genera con IA",
    readyToast: "Quiz \"{{title}}\" pronto",
    perfectResult: "Perfetto! Hai sbloccato un badge.",
    keepGoing: "Continua cosi'.",
    backToQuizzes: "Torna ai quiz",
    questionOf: "Domanda {{current}} di {{total}}",
    exit: "Esci",
    next: "Avanti",
    submitting: "Invio…",
    finish: "Termina",
  },
  es: {
    eyebrow: "Estudio",
    title: "Quiz",
    subtitle: "Ponte a prueba con preguntas de opción múltiple.",
    tabMine: "Mis quiz",
    tabCreate: "Crear",
    emptyList: "Aún no hay quiz. Crea uno en la pestaña \"Crear\".",
    questionsCount: "{{count}} preguntas",
    start: "Empezar",
    topicLabel: "Tema",
    topicPlaceholder: "Ej. Sistema circulatorio",
    subjectLabel: "Materia",
    subjectPlaceholder: "Ej. Biología",
    difficultyLabel: "Dificultad",
    difficultyBase: "Básico",
    difficultyMedium: "Medio",
    difficultyAdvanced: "Avanzado",
    sourceLabel: "Texto de partida (opcional)",
    sourcePlaceholder: "Pega apuntes, o adjunta un audio o una foto de tus apuntes.",
    countLabel: "Número de preguntas: {{count}}",
    generating: "Generando el quiz…",
    generateWithAi: "Generar con IA",
    readyToast: "Quiz \"{{title}}\" listo",
    perfectResult: "¡Perfecto! Has desbloqueado una insignia.",
    keepGoing: "Sigue así.",
    backToQuizzes: "Volver a los quiz",
    questionOf: "Pregunta {{current}} de {{total}}",
    exit: "Salir",
    next: "Siguiente",
    submitting: "Enviando…",
    finish: "Terminar",
  },
  fr: {
    eyebrow: "Étude",
    title: "Quiz",
    subtitle: "Teste-toi avec des questions à choix multiples.",
    tabMine: "Mes quiz",
    tabCreate: "Créer",
    emptyList: "Aucun quiz pour l'instant. Crée-en un dans l'onglet \"Créer\".",
    questionsCount: "{{count}} questions",
    start: "Commencer",
    topicLabel: "Sujet",
    topicPlaceholder: "Ex. Système circulatoire",
    subjectLabel: "Matière",
    subjectPlaceholder: "Ex. Biologie",
    difficultyLabel: "Difficulté",
    difficultyBase: "Facile",
    difficultyMedium: "Moyen",
    difficultyAdvanced: "Avancé",
    sourceLabel: "Texte source (optionnel)",
    sourcePlaceholder: "Colle tes notes, ou joins un audio ou une photo de tes notes.",
    countLabel: "Nombre de questions : {{count}}",
    generating: "Génération du quiz…",
    generateWithAi: "Générer avec l'IA",
    readyToast: "Quiz « {{title}} » prêt",
    perfectResult: "Parfait ! Tu as débloqué un badge.",
    keepGoing: "Continue comme ça.",
    backToQuizzes: "Retour aux quiz",
    questionOf: "Question {{current}} sur {{total}}",
    exit: "Quitter",
    next: "Suivant",
    submitting: "Envoi…",
    finish: "Terminer",
  },
  de: {
    eyebrow: "Lernen",
    title: "Quiz",
    subtitle: "Teste dich mit Multiple-Choice-Fragen.",
    tabMine: "Meine Quiz",
    tabCreate: "Erstellen",
    emptyList: "Noch keine Quiz. Erstelle eines im Tab \"Erstellen\".",
    questionsCount: "{{count}} Fragen",
    start: "Starten",
    topicLabel: "Thema",
    topicPlaceholder: "Z. B. Kreislaufsystem",
    subjectLabel: "Fach",
    subjectPlaceholder: "Z. B. Biologie",
    difficultyLabel: "Schwierigkeit",
    difficultyBase: "Einfach",
    difficultyMedium: "Mittel",
    difficultyAdvanced: "Fortgeschritten",
    sourceLabel: "Ausgangstext (optional)",
    sourcePlaceholder: "Füge Notizen ein oder hänge eine Audiodatei oder ein Foto deiner Notizen an.",
    countLabel: "Anzahl Fragen: {{count}}",
    generating: "Quiz wird erstellt…",
    generateWithAi: "Mit KI generieren",
    readyToast: "Quiz \"{{title}}\" fertig",
    perfectResult: "Perfekt! Du hast ein Abzeichen freigeschaltet.",
    keepGoing: "Weiter so.",
    backToQuizzes: "Zurück zu den Quiz",
    questionOf: "Frage {{current}} von {{total}}",
    exit: "Beenden",
    next: "Weiter",
    submitting: "Senden…",
    finish: "Abschließen",
  },
  pt: {
    eyebrow: "Estudo",
    title: "Quiz",
    subtitle: "Teste-se com perguntas de múltipla escolha.",
    tabMine: "Meus quiz",
    tabCreate: "Criar",
    emptyList: "Nenhum quiz ainda. Crie um na aba \"Criar\".",
    questionsCount: "{{count}} perguntas",
    start: "Começar",
    topicLabel: "Tópico",
    topicPlaceholder: "Ex. Sistema circulatório",
    subjectLabel: "Matéria",
    subjectPlaceholder: "Ex. Biologia",
    difficultyLabel: "Dificuldade",
    difficultyBase: "Básico",
    difficultyMedium: "Médio",
    difficultyAdvanced: "Avançado",
    sourceLabel: "Texto de origem (opcional)",
    sourcePlaceholder: "Cole anotações, ou anexe um áudio ou uma foto das suas anotações.",
    countLabel: "Número de perguntas: {{count}}",
    generating: "Gerando o quiz…",
    generateWithAi: "Gerar com IA",
    readyToast: "Quiz \"{{title}}\" pronto",
    perfectResult: "Perfeito! Você desbloqueou um selo.",
    keepGoing: "Continue assim.",
    backToQuizzes: "Voltar aos quiz",
    questionOf: "Pergunta {{current}} de {{total}}",
    exit: "Sair",
    next: "Avançar",
    submitting: "Enviando…",
    finish: "Terminar",
  },
};
